import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Section: Product Visual Marketing - Yotpo
 * ------------------------------------------------------------------------------
 * A section for showing UGC content.
 * Powered by Yotpo.
 */

import { register } from '@shopify/theme-sections';
import cssClasses from '../helpers/cssClasses';
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-product-yotpo="container"]',
  gallery: '[js-product-yotpo="gallery"]'
};
/**
 * Register the `product-yotpo` section type.
 */

register('product-yotpo', {
  /**
   * Initialise section.
   */
  init() {
    this.cacheNodes();
    this.setupObserver();
  },

  /**
   * Cache selectors.
   * - Cache necessary dom nodes and make available for reuse.
   */
  cacheNodes() {
    const container = document.querySelector("[data-section-id=\"".concat(this.id, "\"]").concat(selectors.container));
    const gallery = document.querySelector("[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.gallery));
    this.cache = {
      container,
      gallery
    };
  },

  setupObserver() {
    const config = {
      childList: true
    }; // Create an observer instance linked to the callback function

    const observer = new MutationObserver(this.nodeMutationHandler.bind(this)); // Start observing the target node for configured mutations

    observer.observe(this.cache.gallery, config);
    this.observer = observer;
  },

  nodeMutationHandler(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        this.hideIfEmpty();
      }
    }
  },

  hideIfEmpty() {
    var _this$cache$gallery$i;

    const isEmpty = ((_this$cache$gallery$i = this.cache.gallery.innerHTML) === null || _this$cache$gallery$i === void 0 ? void 0 : _this$cache$gallery$i.trim()) === "";

    if (isEmpty) {
      this.cache.container.classList.add(cssClasses.hidden);
    } else {
      this.cache.container.classList.remove(cssClasses.hidden);
    }
  },

  /**
   * Callback function when section is loaded via `sections.load()` or by
   * the Theme Editor `shopify:section:load` event.
   */
  onLoad() {
    this.init();
  },

  onUnload() {
    // Disconnect observer when a section instance is unloaded
    this.observer.disconnect();
  }

});